export default "assets/images/duration-418e97ca.svg";